import * as ALL_ROUTES from './routing';

const {
  COMMON,
  IMPORT,
  ORDERS,
  PRODUCTS,
  SETTINGS,
  SUMMARY,
  SUPPLIES,
  PHYSICAL_SETS,
  ADMIN_PANEL,
  IMPORTS_CHZ,
  DOCUMENTS,
} = ALL_ROUTES;

export const USER_PRIVILEGES = {
  ADMIN: 'Полный доступ',
  DASHBOARD_DATA_READ: 'Просмотр сводки',
  ORDERS_READ: 'Просмотр заказов',
  ORDERS_WRITE: 'Редактирование заказов',
  PURCHASE_ORDERS_READ: 'Просмотр поставок',
  PURCHASE_ORDERS_WRITE: 'Редактирование поставок',
  PRODUCTS_READ: 'Просмотр товаров',
  PRODUCTS_WRITE: 'Редактирование товаров',
  SETTINGS_READ: 'Просмотр настроек',
  SETTINGS_WRITE: 'Редактирование настроек',
  SHOP_TEMPLATE_READ: 'Просмотр витрины',
  SHOP_TEMPLATE_WRITE: 'Редактирование витрины',
  PHYSICAL_SET_ORDER_READ: 'Просмотр комплектов',
  PHYSICAL_SET_ORDER_WRITE: 'Редактирование комплектов',
  ADMIN_READ: 'Чтение админинстраторских настроек',
  ADMIN_WRITE: 'Редактирование админинстраторских настроек',
};

export const USER_PRIVILEGES_ROUTING = [
  { DASHBOARD_DATA_READ: [SUMMARY] },
  { ORDERS_READ: [ORDERS, IMPORT] },
  { ORDERS_WRITE: [ORDERS, IMPORT] },
  { PURCHASE_ORDERS_READ: [SUPPLIES] },
  { PURCHASE_ORDERS_WRITE: [SUPPLIES] },
  { PRODUCTS_READ: [PRODUCTS, IMPORT] },
  { PRODUCTS_WRITE: [PRODUCTS, IMPORT] },
  { SETTINGS_READ: [SETTINGS] },
  { SETTINGS_WRITE: [SETTINGS] },
  { PHYSICAL_SET_ORDER_READ: [PHYSICAL_SETS] },
  { PHYSICAL_SET_ORDER_WRITE: [PHYSICAL_SETS] },
  { ADMIN_READ: [PHYSICAL_SETS] },
  { PHYSICAL_SET_ORDER_WRITE: [PHYSICAL_SETS] },
  { ADMIN_READ: [ADMIN_PANEL] },
  { ADMIN_WRITE: [ADMIN_PANEL] },
  { IMPORTS_CHZ: [IMPORTS_CHZ] },
  { DOCUMENTS: [DOCUMENTS] },
].reduce(
  (a, c) => {
    a[Object.keys(c)[0]] = [].concat(...c[Object.keys(c)[0]], COMMON);
    return a;
  },
  {
    ADMIN: [].concat(...Object.values(ALL_ROUTES)),
  },
);
